// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    SquareSplitHorizontal,
    SquareSplitVertical,
    SquareSquare,
    SquareStack,
    SquareStar,
    SquareStop,
    SquareTerminal,
    SquareText,
    SquareUser,
    SquareUserRound,
    SquareX,
    SquaresExclude,
    SquaresIntersect,
    SquaresSubtract,
    SquaresUnite,
    Squircle,
    SquircleDashed,
    Squirrel,
    Stamp,
    Star,
    StarCheck,
    StarHalf,
    StarMinus,
    StarOff,
    StarPlus,
    StarX,
    StepBack,
    StepForward,
    Stethoscope,
    Sticker,
    StickyNote,
    StickyNoteCheck,
    StickyNoteMinus,
    StickyNoteOff,
    StickyNotePlus,
    StickyNoteX,
    StickyNotes,
    Stone,
    Store,
    StretchHorizontal,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "square-split-horizontal" through "stretch-horizontal", inclusive. */
const shard: Record<string, LucideIcon> = {
    "square-split-horizontal": SquareSplitHorizontal,
    "square-split-vertical": SquareSplitVertical,
    "square-square": SquareSquare,
    "square-stack": SquareStack,
    "square-star": SquareStar,
    "square-stop": SquareStop,
    "square-terminal": SquareTerminal,
    "square-text": SquareText,
    "square-user": SquareUser,
    "square-user-round": SquareUserRound,
    "square-x": SquareX,
    "squares-exclude": SquaresExclude,
    "squares-intersect": SquaresIntersect,
    "squares-subtract": SquaresSubtract,
    "squares-unite": SquaresUnite,
    squircle: Squircle,
    "squircle-dashed": SquircleDashed,
    squirrel: Squirrel,
    stamp: Stamp,
    star: Star,
    "star-check": StarCheck,
    "star-half": StarHalf,
    "star-minus": StarMinus,
    "star-off": StarOff,
    "star-plus": StarPlus,
    "star-x": StarX,
    "step-back": StepBack,
    "step-forward": StepForward,
    stethoscope: Stethoscope,
    sticker: Sticker,
    "sticky-note": StickyNote,
    "sticky-note-check": StickyNoteCheck,
    "sticky-note-minus": StickyNoteMinus,
    "sticky-note-off": StickyNoteOff,
    "sticky-note-plus": StickyNotePlus,
    "sticky-note-x": StickyNoteX,
    "sticky-notes": StickyNotes,
    stone: Stone,
    store: Store,
    "stretch-horizontal": StretchHorizontal,
};

export default shard;
